'use strict'

export let norwegian_releaseDetails={
  general: {
    projectManager: "Produktleder"
  },
  themes: {
    plan: {
      title: "Plan"
    }
  }
};



// WEBPACK FOOTER //
// ./views/product/labels/norwegian#releaseDetails.js